import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "styled-components";
var _Search, _RightMenu, _UserMenu;
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container } from "@crehana/ui";
import cn from "classnames";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import UserMenu from "../../MainMenu/components/UserMenu";
import { useMainMenuContext } from "../../MainMenu/hooks";
import Feedback from "../components/Feedback";
import RightMenu from "../components/RightMenu";
import Search from "../components/Search";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DashboardMenuDesktop = function DashboardMenuDesktop(_ref) {
  var feedbackUrl = _ref.feedbackUrl,
    shouldRenderSearch = _ref.shouldRenderSearch;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    position = _useMainMenuContext.position,
    className = _useMainMenuContext.className,
    cssProp = _useMainMenuContext.css,
    style = _useMainMenuContext.style,
    dataTestId = _useMainMenuContext['data-testid'],
    dataCy = _useMainMenuContext['data-cy'],
    isTransparent = _useMainMenuContext.isTransparent,
    dashboardTitle = _useMainMenuContext.dashboardTitle;
  return /*#__PURE__*/_jsx(_StyledNav, {
    className: cn('main-menu w-full flex justify-center', theme.nav.textColorClassName, theme.nav.dashboardPaddingClassNames, position, _defineProperty(_defineProperty({}, theme.nav.backgroundColorClassName, !isTransparent), 'top-0 left-0 right-0', position === 'sticky' || position === 'absolute'), className),
    style: style,
    "data-testid": dataTestId,
    "data-cy": dataCy,
    $_css: theme.nav.zIndex,
    $_css2: cssProp,
    children: /*#__PURE__*/_jsxs(Container, {
      type: "dashboard",
      className: cn('flex items-center', dashboardTitle ? 'justify-between' : 'justify-end'),
      children: [dashboardTitle && /*#__PURE__*/_jsx("h1", {
        className: "font-h2",
        children: dashboardTitle
      }), /*#__PURE__*/_jsxs("div", {
        className: "right-menu flex items-center flex-shrink-0",
        "data-tour": "dashboard-header-options",
        children: [shouldRenderSearch && (_Search || (_Search = /*#__PURE__*/_jsx(Search, {}))), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center ml-24",
          children: [feedbackUrl && /*#__PURE__*/_jsx(Feedback, {
            feedbackUrl: feedbackUrl
          }), _RightMenu || (_RightMenu = /*#__PURE__*/_jsx(RightMenu, {})), _UserMenu || (_UserMenu = /*#__PURE__*/_jsx(UserMenu, {}))]
        })]
      })]
    })
  });
};
export default DashboardMenuDesktop;
var _StyledNav = /*#__PURE__*/_styled("nav").withConfig({
  componentId: "sc-1s5km7g-0"
})(["\n        transition: ", ";\n        z-index: ", ";\n        ", "\n      "], function (props) {
  return props.theme.transition(['background-color', 'color']);
}, function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});